<mat-card appearance="outlined" *ngIf="options">
  <div echarts [options]="options" class="inthraction-graph"></div>
  <button mat-icon-button (click)="resetChart()" title="Reset Chart" class="reset-btn">
    <mat-icon>undo</mat-icon>
  </button>
</mat-card>
